import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const Title: FC<{ projectId: number }> = () => {
  return (
    <Row>
      <Col flex={1}>
        <strong>
          <FormattedMessage id="project.overview.tasks_completed_late.title" />
        </strong>
      </Col>
    </Row>
  );
};
